import styled from 'styled-components'
import tw from 'twin.macro'

export const StyledInput = styled.input`
  transition: border 0.2s ease-in-out;
  min-width: 280px;

  &:focus + .label,
  &:active + .label,
  &.filled + .label {
    ${tw`text-brand-600!`}
    font-size: 0.75rem !important;
    top: -0.1rem;
  }
`

export const Label = styled.label`
  transition: all 0.2s ease-out;
  top: 0.65rem;
  left: 0;
  pointer-events: none;

  &.filled {
    font-size: 0.75rem !important;
    top: -0.1rem;
  }
`
